import React from "react";
import { PAYMENT_METHOD_MAP } from "src/config/paymentMethods";

// Renders the seller's enabled payment methods as a row of small tiles —
// real official logos (src/assets/images/payment/) for
// Visa/Mastercard/Amex/PayPal/UPI, and a generic icon for method categories
// that aren't a single brand (Netbanking, Wallets, Cash on Delivery).
//
// `compact`: bare icons with no tile/border, sized to sit inline in a line
// of text (e.g. next to "Secure Checkout" on the checkout page) instead of
// the boxed showcase used in the footer's "We accept" section.
const PaymentMethodsRow = ({ methods = [], compact = false }) => {
  const enabled = methods
    .map((id) => PAYMENT_METHOD_MAP[id])
    .filter(Boolean);

  if (enabled.length === 0) return null;

  if (compact) {
    return (
      <>
        {enabled.map((method) =>
          method.kind === "logo" ? (
            <img
              key={method.id}
              src={method.logo}
              alt={method.label}
              title={method.label}
              className="h-4 w-auto object-contain"
            />
          ) : (
            <span key={method.id} title={method.label} className="text-gray-500">
              <method.Icon size={16} />
            </span>
          )
        )}
      </>
    );
  }

  return (
    <div className="flex flex-wrap items-center gap-2">
      {enabled.map((method) => (
        <div
          key={method.id}
          title={method.label}
          className="h-9 min-w-[3rem] px-2.5 flex items-center justify-center rounded-lg border border-gray-100 bg-white shadow-sm"
        >
          {method.kind === "logo" ? (
            <img src={method.logo} alt={method.label} className="h-5 w-auto object-contain" />
          ) : (
            <method.Icon size={20} className="text-gray-500" />
          )}
        </div>
      ))}
    </div>
  );
};

export default PaymentMethodsRow;
